<form id="reportsEditForm" [formGroup]="reportsEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="col-12">
      <label class="control-label required">{{'i18n.domain.reports.filter.fields.reportType' | translate}}</label><br>
      <ejs-dropdownlist id="reportType"
                        formControlName="reportType"
                        [fields]="enumDropdownSettings"
                        [showClearButton]="true"
                        [dataSource]="types"></ejs-dropdownlist>
      <app-error-messages [control]="reportsEditForm.controls.reportType"></app-error-messages>
    </div>
  </div>
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.TagsPerParker]) {
    <div>
      <app-tags-form [form]="reportsEditForm"></app-tags-form>
    </div>
  }
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerRegistrations]) {
    <div>
      <app-parker-registration-form [form]="reportsEditForm"></app-parker-registration-form>
    </div>
  }
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.FalseRecordings]) {
    <div>
      <app-false-recording-form [form]="reportsEditForm"></app-false-recording-form>
    </div>
  }
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerTurnover]) {
    <div>
      <app-parker-turnover-form [form]="reportsEditForm"></app-parker-turnover-form>
    </div>
  }
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerExtract]) {
    <div>
      <app-parker-extract-form [form]="reportsEditForm"></app-parker-extract-form>
    </div>
  }
  @if (reportsEditForm.controls.reportType.value === ReportType[ReportType.DeviceStatus]) {
    <div>
      <app-device-status-form [form]="reportsEditForm"></app-device-status-form>
    </div>
  }
  <!-- @if(reportsEditForm.controls.reportType.value === ReportType[ReportType.ParkerPerTariff]) {
    <div>
      <app-parker-tariff-form [form]="reportsEditForm"></app-parker-tariff-form>
    </div>
  } -->
</form>
